import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockDefaultTxt.module.css';

// Wine sparkle decoration (same SVG as rest of landing)
const SparkleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={css.sparkle}
  >
    <path
      d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z"
      fill="#8C265C"
    />
  </svg>
);

/**
 * Renders heading3 title parsing **bold** markers as wine-accent spans.
 */
const AccentTitle = ({ data }) => {
  if (!data?.content) return null;
  const parts = data.content.split(/\*\*(.*?)\*\*/g);
  return (
    <h3 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={css.titleAccent}>{part}</span>
        ) : (
          part
        )
      )}
    </h3>
  );
};

const BlockDefaultTxt = props => {
  const {
    blockId,
    className,
    rootClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    options,
    alignment,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const hasFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClass = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  }[alignment];

  return (
    <BlockContainer id={blockId} className={classes}>
      {hasFields ? (
        <div className={classNames(css.content, alignmentClass)}>
          {title?.content ? (
            <div className={css.titleRow}>
              <SparkleIcon />
              <AccentTitle data={title} />
            </div>
          ) : null}
          <Field data={text} className={css.description} options={options} />
          {callToAction?.content ? (
            <Field data={callToAction} className={ctaButtonClass} options={options} />
          ) : null}
        </div>
      ) : null}
    </BlockContainer>
  );
};

export default BlockDefaultTxt;
